import guarantee from './guarantee.svg';
import payment from './payment.svg';
import refund from './refund.svg';
import delivery from './delivery.svg';

export const images = { guarantee, payment, refund, delivery };
